import { safeParse } from 'secure-json-parse';

export const formatJSONPreserveOrder = (data = '{}'): Map<string, string> => {
  const dataMap = new Map();
  const parsedData = safeParse(data);
  safeParse(data, (key) => {
    const parsedValue = parsedData[key];
    if (!key || parsedValue === undefined) return;
    typeof parsedValue !== 'string'
      ? dataMap.set(key, JSON.stringify(parsedValue))
      : dataMap.set(key, parsedValue);
  });
  return dataMap;
};
